var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.rulesText,"name":_vm.name,"mode":_vm.mode},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default"),_c('div',{staticClass:"form-guide"},[_vm._v(" "+_vm._s(errors[0])+" ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }